import normalize from 'json-api-normalizer';
import User from './user.js';

export default class Broadcast {

    static from (jsonapi) {
        let normalizedJSONapi = normalize(jsonapi);
        if (normalizedJSONapi) {
            let keys = Object.keys(normalizedJSONapi.broadcasts);
            if (keys.length > 0 && Array.isArray(jsonapi.data)) {
                let retVal = {};
                keys.forEach( function ( castId ) {
                    retVal[castId] = Broadcast.makeBroadcast(normalizedJSONapi.broadcasts[castId], normalizedJSONapi);
                });
                return retVal;
            } else {
                return Broadcast.makeBroadcast(normalizedJSONapi.broadcasts[keys[0]], normalizedJSONapi);
            }
        }
    }

    static makeBroadcast (jsonapi, normalizedJSONapi) {

        const { id, attributes } = jsonapi;

        return new Broadcast ( Object.assign({}, {id: id}, attributes) );
    }

    constructor ({ id, level, targeted, dismissible, body, firstViewedAt, startsAt, endsAt }) {

        this.id               = id ? id : -1;
        this.level            = level ? level : 'notice';
        this.targeted         = targeted ? targeted : false;
        this.dismissible      = dismissible ? dismissible : false;
        this.body             = body ? body : '';
        this.first_viewed     = firstViewedAt ? firstViewedAt : null;

        this.starts_at        = startsAt ? startsAt : null;
        this.ends_at          = endsAt ? endsAt : '';

    }

}
